import common from './en/common'
import home from './en/home'
import prompt from './en/prompt'
import gszl from './en/gszl'
import about from './en/about'
import product from './en/product'
export default {
    common,
    home,
    prompt,
    gszl,
    about,
    product,
    msg:'你好,{name},{age}',

}